export const CURRENT_USER_DATA = "CURRENT_USER_DATA";
export const SHOW_USER_PROFILE_LOADER = "USER_PROFILE_LOADER";
export const IS_ERROR_FETCHING_USER_DETAILS = "IS_ERROR_FETCHING_USER_DETAILS";
export const SET_TAB = "SET_TAB";
export const RESET_TAB = "RESET_TAB";
export const EDIT_DETAILS_HANDLER = "EDIT_DETAILS_HANDLER";
